
import { useState, useEffect } from "react";
import calendarStyles from "pages/landingpage/calendar/CalendarSection.module.css";
import commonStyles from "components/commonStyle/commonStyle.module.css";
import styles from "./BookingManagementTimeTable.module.css";
import { IoIosList } from "react-icons/io";
import { IoCalendarOutline } from "react-icons/io5";
import { WorkTimeSlot, HolidaySlot } from "modules/calendar-worktime-holiday";
import { fetchWorkSlots, fetchHolidaySlots } from "services/workTime/calendar-service";
import { BookingList } from "modules/booking";
import { getMonday, getWeekdayLetter, isSameDate, uniqueTimeSlots } from "utils/calender";
import CalendarControler from "components/calender/calenderController";
import CalenderBottons from "components/calender/calenderBottons";
import { getintervalBookingsemploy } from "services/booking/get-interval-bookings-employ";
import EmployBookingPopup from "../bookinkPooup/BookingPopup";
import EmployCancelPopup from "../bookinkPooup/employCancelPopup";
import EmployUnregesteredBookingPopup from "../bookinkPooup/bookingUnregisteredPopup";


export default function BookingManagementTimeTable() {
    const [workTimeSlots, setWorkTimeSlots] = useState<WorkTimeSlot[]>([]);
    const [holidaySlots, setHolidaySlots] = useState<HolidaySlot[]>([]);
    const [weekOffset, setWeekOffset] = useState(0);
    const [week, setWeek] = useState<Date[]>([]);
    const [bookingList, setBookingList] = useState<BookingList[]>([]);
    const [bookingListDaily, setBookingListDaily] = useState<BookingList[]>([]);
    const [selectedView, setSelectedView] = useState('table');
    const currentTime = new Date();
    const times = uniqueTimeSlots(workTimeSlots, week);
    const [isBookingPopupOpen, setIsBookingPopupOpen] = useState(false);
    const handleOpenBookingPopup = () => setIsBookingPopupOpen(true);
    const handleCloseBookingPopup = () => {
        handleCurrentDay();
        handleCurrentWeek();
        setIsBookingPopupOpen(false);
    }
    const [isCancelPopupOpen, setIsCancelPopupOpen] = useState(false);
    const handleOpenCancelPopup = () => setIsCancelPopupOpen(true);
    const handleCloseCancelPopup = () => {
        handleCurrentDay();
        handleCurrentWeek();
        setIsCancelPopupOpen(false);
    }
    const [isPopupUnregesterBookingOpen, setIsPopupUnregesterBookingOpen] = useState(false);
    const [dayOffset, setDayOffset] = useState(0);
    const [currentDay, setCurrentDay] = useState(new Date());
    const handleCloseUnregesterBookingPopup = () => {
        setIsPopupUnregesterBookingOpen(false);
        fetchData();
    }
    const handelOnchange = () => {
        if (isBookingPopupOpen) {
            setIsBookingPopupOpen(false);
            setIsPopupUnregesterBookingOpen(true);
        } else if (isPopupUnregesterBookingOpen) {
            setIsPopupUnregesterBookingOpen(false);
            setIsBookingPopupOpen(true);
        }
    };

    const handleTableView = () => setSelectedView('table');
    const handlelistView = () => setSelectedView('list');

    const fetchData = async () => {
        try {
            const workData = await fetchWorkSlots();
            const holidayData = await fetchHolidaySlots();
            setWorkTimeSlots(workData);
            setHolidaySlots(holidayData);
        } catch (error) {
            console.error("Fehler beim Abrufen der daten:", error);
        }
    };




    const updateWeeks = async (offset: number) => {
        const monday = getMonday(new Date());
        const newMonday = new Date(monday);
        newMonday.setDate(monday.getDate() + offset * 7);

        const newWeek = [];
        for (let i = 0; i < 7; i++) {
            const currentDay = new Date(newMonday);
            currentDay.setDate(newMonday.getDate() + i);
            if (currentDay.getDay() >= 1 && currentDay.getDay() <= 5) {
                newWeek.push(currentDay);
            }
        }
        const friday = new Date(newMonday);
        friday.setDate(newMonday.getDate() + 4);
        const rawBookingData = await getintervalBookingsemploy(newMonday, friday);
        if (rawBookingData.Kids_bookings_data) {
            const bookingData = rawBookingData.Kids_bookings_data.map((booking: any) => ({
                ...booking,
                name: `${booking.kid_first_name} ${booking.kid_last_name}`,
                
            }));
            setBookingList(bookingData);
            console.log(bookingList)
        }
        setWeek(newWeek);
    };

    const handleCurrentWeek = () => {
        setWeekOffset(0);
        updateWeeks(0);

    };

    const handleNextWeek = () => {
        setWeekOffset((prevOffset) => {
            const newOffset = prevOffset + 1;
            updateWeeks(newOffset);
            return newOffset;
        });
    };

    const handlePreviousWeek = () => {
        setWeekOffset((prevOffset) => {
            const newOffset = prevOffset - 1;
            updateWeeks(newOffset);
            return newOffset;
        });
    };

    const updateDayBookings = async (selectedDate: Date) => {
        try {
            const rawBookingData = await getintervalBookingsemploy(selectedDate, selectedDate);

            if (rawBookingData.Kids_bookings_data) {
                const bookingData = rawBookingData.Kids_bookings_data.map((booking: any) => ({
                    ...booking,
                    name: `${booking.kid_first_name} ${booking.kid_last_name}`,
                }));

                setBookingListDaily(bookingData);
            }
        } catch (error) {
            console.error("Fehler beim Abrufen der Tagesbuchungen:", error);
        }
    };

    const handleCurrentDay = () => {
        setDayOffset(0);
        const today = new Date();
        setCurrentDay(today);
        updateDayBookings(today);
    };
    const handleNextDay = () => {
        setDayOffset(prev => prev + 1);
        setCurrentDay(prev => {
            const newDate = new Date(prev);
            newDate.setDate(newDate.getDate() + 1);
            updateDayBookings(newDate);
            return newDate;
        });
    };

    const handlePreviousDay = () => {
        setDayOffset(prev => prev - 1);
        setCurrentDay(prev => {
            const newDate = new Date(prev);
            newDate.setDate(newDate.getDate() - 1);
            updateDayBookings(newDate);
            return newDate;
        });
    };

    useEffect(() => {
        fetchData();
        updateWeeks(0);
        updateDayBookings(new Date());
    }, []);

    return (
        <div className={calendarStyles.container}>
            <div className={styles.CalendarPanel}>
                <div className={styles.CalendarController}>
                    {selectedView === 'list' ?
                        <CalendarControler
                            currentDate={currentTime}
                            week={week}
                            weekOffset={dayOffset}
                            onCurrentWeek={handleCurrentDay}
                            onPreviousWeek={handlePreviousDay}
                            onNextWeek={handleNextDay}
                            showPrevious={true}
                            isDailyView={true}
                            selectedDate={currentDay}
                            dayOffset={dayOffset} />

                        : <CalendarControler
                            currentDate={currentTime}
                            week={week}
                            weekOffset={weekOffset}
                            onCurrentWeek={handleCurrentWeek}
                            onPreviousWeek={handlePreviousWeek}
                            onNextWeek={handleNextWeek}
                            showPrevious={true} />}
                </div>
                <div className={styles.ButtonContainer}>
                    <CalenderBottons handleOpenBookingPopup={handleOpenBookingPopup} handleOpenCancelPopup={handleOpenCancelPopup} />
                    <div className={styles.veiwButtonContainer}>
                        <button className={`${commonStyles.commonButton}  ${selectedView === 'table' ? styles.activeViewButton : styles.viewButton}`} onClick={handleTableView}>
                            <IoCalendarOutline />
                        </button>
                        <button className={`${commonStyles.commonButton} ${selectedView === 'list' ? styles.activeViewButton : styles.viewButton}`} onClick={handlelistView}>
                            <IoIosList />
                        </button>
                    </div>
                </div>
                <EmployBookingPopup isOpen={isBookingPopupOpen} onClose={handleCloseBookingPopup} onChange={handelOnchange} />
                <EmployCancelPopup isOpen={isCancelPopupOpen} onClose={handleCloseCancelPopup} />
                <EmployUnregesteredBookingPopup isOpen={isPopupUnregesterBookingOpen} onClose={handleCloseUnregesterBookingPopup} onChange={handelOnchange} />

            </div>
            <table className={`${calendarStyles.table} ${styles.table}`}>
                <thead>
                    <tr>
                        <th>Uhrzeit</th>
                        {week.slice(0, 5).map((day, index) => (
                            <th key={index}> <div className={styles.dayAndDate}>
                                {getWeekdayLetter(day).slice(0, 2)}
                                <div className={isSameDate(day, currentTime)
                                    ? calendarStyles.currentDay
                                    : ""}>
                                    {day.getDate().toString().padStart(2, '0')}
                                </div>
                            </div>
                            </th>
                        ))}
                    </tr>
                </thead>
                {/* show the calender based on kids age under over 3 year */}
                {/* <tbody>

                    {selectedView === 'table' && times.map((time, index) => (
                        <tr key={`${index}-week1`}>
                            <td className={calendarStyles.kalenderUhrzeit}>{time}</td>
                            {week.slice(0, 5).map((day, dayIndex) => {

                                const slot = workTimeSlots.find((slot) =>
                                    slot.day_of_week === getWeekdayLetter(day) &&
                                    slot.start_time.substring(0, 5) === time.split(" - ")[0] &&
                                    slot.end_time.substring(0, 5) === time.split(" - ")[1]
                                );
                                const holidaysInDay = holidaySlots.filter((holidaySlot) => {
                                    const holidayDate = new Date(holidaySlot.date);
                                    return isSameDate(day, holidayDate);
                                });

                                const placesLeft = slot ? Number(slot.number_of_places) : 0;
                                const placesUnder3 = bookingList
                                    ? bookingList.filter(
                                        (booking) =>
                                            booking.age < 3 &&
                                            booking.work_time_slot_id == slot?.id &&
                                            (
                                                new Date(booking.date).toDateString() === day.toDateString() && booking.status === "confirmed" ||
                                                (booking.recurrence_date_1 && new Date(booking.recurrence_date_1).toDateString() === day.toDateString()) && booking.recurrence_date_1_status === "confirmed" ||
                                                (booking.recurrence_date_2 && new Date(booking.recurrence_date_2).toDateString() === day.toDateString()) && booking.recurrence_date_2_status === "confirmed" ||
                                                (booking.recurrence_date_3 && new Date(booking.recurrence_date_3).toDateString() === day.toDateString()) && booking.recurrence_date_3_status === "confirmed"
                                            )
                                    ).length
                                    : 0;
                                const placesOver3 = bookingList
                                    ? bookingList.filter(
                                        (booking) =>
                                            booking.age >= 3 &&
                                            booking.work_time_slot_id == slot?.id &&
                                            (
                                                new Date(booking.date).toDateString() === day.toDateString() && booking.status === "confirmed" ||
                                                (booking.recurrence_date_1 && new Date(booking.recurrence_date_1).toDateString() === day.toDateString()) && booking.recurrence_date_1_status === "confirmed" ||
                                                (booking.recurrence_date_2 && new Date(booking.recurrence_date_2).toDateString() === day.toDateString()) && booking.recurrence_date_2_status === "confirmed" ||
                                                (booking.recurrence_date_3 && new Date(booking.recurrence_date_3).toDateString() === day.toDateString()) && booking.recurrence_date_3_status === "confirmed" 
                                            )
                                    ).length
                                    : 0;
                                const isFull = slot ? placesOver3 + placesUnder3 === Number(slot.number_of_places) : false;
                                const isClosed = !slot || holidaysInDay.some(holiday => holiday.block === slot.id);

                                return (
                                    <td key={dayIndex} className={isFull || placesLeft === 0 || isClosed ? calendarStyles.past : ""}>
                                        <div>
                                            {isClosed ? (
                                                <center>
                                                    <span className={calendarStyles.geschlossen}>geschlossen</span>
                                                </center>
                                            ) : (
                                                <div className={styles.infoContainer}>
                                                    <div className={styles.infoContainerLine}>
                                                        <div className={`${calendarStyles.platzContainer}`}>
                                                            <span className={isFull || placesLeft === 0 || isClosed ? calendarStyles.platzNumbedisble : calendarStyles.platzNumber}>
                                                                {placesUnder3}
                                                            </span>
                                                            <span className={calendarStyles.platzLebel}>Plätze</span>
                                                        </div>
                                                        <p>u 3 J</p>
                                                    </div>
                                                    <div className={styles.infoContainerLine}>
                                                        <div className={`${calendarStyles.platzContainer}`}>
                                                            <span className={isFull || placesLeft === 0 || isClosed ? calendarStyles.platzNumbedisble : calendarStyles.platzNumber}>
                                                                {placesOver3}
                                                            </span>
                                                            <span className={calendarStyles.platzLebel}>Plätze</span>
                                                        </div>
                                                        <p>ü 3 J</p>
                                                    </div>

                                                </div>
                                            )
                                            }
                                        </div>
                                    </td>
                                );
                            })}
                        </tr>
                    ))}

                </tbody> */}

                <tbody>

                    {selectedView === 'table' && times.map((time, index) => (
                        <tr key={`${index}-week1`}>
                            <td className={calendarStyles.kalenderUhrzeit}>{time}</td>
                            {week.slice(0, 5).map((day, dayIndex) => {

                                const slot = workTimeSlots.find((slot) =>
                                    slot.day_of_week === getWeekdayLetter(day) &&
                                    slot.start_time.substring(0, 5) === time.split(" - ")[0] &&
                                    slot.end_time.substring(0, 5) === time.split(" - ")[1]
                                );
                                const holidaysInDay = holidaySlots.filter((holidaySlot) => {
                                    const holidayDate = new Date(holidaySlot.date);
                                    return isSameDate(day, holidayDate);
                                });

                                const isFullClosed = holidaysInDay.some(holiday => holiday.is_full_day) ||
                                    holidaysInDay.length === workTimeSlots.filter((slot) => {
                                        return slot.day_of_week === getWeekdayLetter(day);
                                    }).length
                                if (isFullClosed) {
                                    return index === 0 ? (
                                        <td key={dayIndex} rowSpan={times.length} className={`${calendarStyles.geschlossen} ${calendarStyles.past}`}>
                                            <center>
                                                <span className={styles.geschlossen}>geschlossen</span>
                                            </center>
                                        </td>
                                    ) : (null);
                                } else {
                                    const placesLeft = slot ? Number(slot.number_of_places) : 0;
                                    const filteredBookingList = bookingList
                                        ? bookingList.filter(
                                            (booking) =>

                                                booking.work_time_slot_id == slot?.id &&
                                                (
                                                    (new Date(booking.date).toDateString() === day.toDateString() && booking.status === "confirmed" && booking.recurrence === "onetime") ||
                                                    booking.recurrence === "serial" && (
                                                        (booking.recurrence_date_0 && new Date(booking.recurrence_date_0).toDateString() === day.toDateString()) && booking.recurrence_date_0_status === "confirmed" ||
                                                        (booking.recurrence_date_1 && new Date(booking.recurrence_date_1).toDateString() === day.toDateString()) && booking.recurrence_date_1_status === "confirmed" ||
                                                        (booking.recurrence_date_2 && new Date(booking.recurrence_date_2).toDateString() === day.toDateString()) && booking.recurrence_date_2_status === "confirmed" ||
                                                        (booking.recurrence_date_3 && new Date(booking.recurrence_date_3).toDateString() === day.toDateString()) && booking.recurrence_date_3_status === "confirmed"
                                                    )
                                                )
                                        )
                                        : [];

                                    const isFull = slot ? filteredBookingList.length === Number(slot.number_of_places) : false;
                                    const isClosed = !slot || holidaysInDay.some(holiday => holiday.block === slot.id);

                                    return (
                                        <td key={dayIndex} className={isFull || placesLeft === 0 || isClosed ? calendarStyles.past : ""}>
                                            <div>
                                                {isClosed ? (
                                                    <center>
                                                        <span className={calendarStyles.geschlossen}>geschlossen</span>
                                                    </center>
                                                ) : (
                                                    <div className={styles.infoContainer}>
                                                        <div className={styles.infoContainerLine}>
                                                            <div className={`${calendarStyles.platzContainer}`}>
                                                                <span className={isFull || placesLeft === 0 || isClosed ? calendarStyles.platzNumbedisble : calendarStyles.platzNumber}>
                                                                    {filteredBookingList.length}
                                                                </span>
                                                                <span className={calendarStyles.platzLebel}>Plätze</span>
                                                            </div>
                                                        </div>
                                                        {filteredBookingList.map((booking, idx) => (
                                                            <div key={idx} className={styles.infoContainerLine}>
                                                                <span>{booking.name} </span>
                                                                <span> - {booking.age} J</span>
                                                                <span> - ({booking.profile_status})</span>  
                                                            </div>
                                                        ))}


                                                    </div>
                                                )
                                                }
                                            </div>
                                        </td>
                                    );
                                }
                            })}
                        </tr>
                    ))}

                </tbody>
            </table>
            {selectedView === 'list' && (
                <div className={styles.tablesContainer}>
                    <table className={styles.subTable}>
                        <thead>
                            <tr>
                                <th>Uhrzeit</th>
                                <th>Name</th>
                                <th>Alter</th>
                                <th>Status</th>
                            </tr>
                        </thead>
                        <tbody>
                            {times.slice(0, times.length / 2).map((time, index) => {
                                const selectedDate = currentDay;
                                const slot = workTimeSlots.find((slot) =>
                                    slot.day_of_week === getWeekdayLetter(selectedDate) &&
                                    slot.start_time.substring(0, 5) === time.split(" - ")[0] &&
                                    slot.end_time.substring(0, 5) === time.split(" - ")[1]
                                );



                                
                                const selectedDayBooking = bookingListDaily

                                    ? bookingListDaily.filter(
                                        (booking) =>
                                            booking.work_time_slot_id == slot?.id &&
                                           (
                                                (new Date(booking.date).toDateString() === selectedDate.toDateString()&& booking.status === "confirmed" && booking.recurrence === "onetime") ||
                                                booking.recurrence === "serial" && (
                                                ((booking.recurrence_date_0 && new Date(booking.recurrence_date_0).toDateString() === selectedDate.toDateString()) && booking.recurrence_date_0_status === "confirmed") ||
                                                ((booking.recurrence_date_1 && new Date(booking.recurrence_date_1).toDateString() === selectedDate.toDateString()) && booking.recurrence_date_1_status === "confirmed") ||
                                                ((booking.recurrence_date_2 && new Date(booking.recurrence_date_2).toDateString() === selectedDate.toDateString()) && booking.recurrence_date_2_status === "confirmed") ||
                                                ((booking.recurrence_date_3 && new Date(booking.recurrence_date_3).toDateString() === selectedDate.toDateString()) && booking.recurrence_date_3_status === "confirmed")
                                            ))
                                    )
                                    : [];

                                return (
                                    <>
                                        <tr>
                                            <td rowSpan={selectedDayBooking.length + 1} className={styles.Uhrzeit}>
                                                {time}
                                            </td>
                                        </tr>
                                        {selectedDayBooking.map((student, studentIndex) => (
                                            <tr key={studentIndex}>
                                                <td>{student.name}</td>
                                                <td>{student.age} J.</td>
                                                <td>{student.profile_status}</td> 
                                            </tr>
                                        ))}
                                    </>
                                );
                            })}
                        </tbody>
                    </table>

                    <table className={styles.subTable}>
                        <thead>
                            <tr>
                                <th>Uhrzeit</th>
                                <th>Name</th>
                                <th>Alter</th>
                                                                <th>Status</th>

                            </tr>
                        </thead>
                        <tbody>
                            {times.slice(times.length / 2).map((time, index) => {
                                const selectedDate = currentDay;
                                const slot = workTimeSlots.find((slot) =>
                                    slot.day_of_week === getWeekdayLetter(selectedDate) &&
                                    slot.start_time.substring(0, 5) === time.split(" - ")[0] &&
                                    slot.end_time.substring(0, 5) === time.split(" - ")[1]
                                );



                                const selectedDayBooking = bookingListDaily
                                    ? bookingListDaily.filter(
                                        (booking) =>
                                            booking.work_time_slot_id == slot?.id &&
                                            (
                                                (new Date(booking.date).toDateString() === selectedDate.toDateString()&& booking.status === "confirmed" && booking.recurrence === "onetime") ||
                                                booking.recurrence === "serial" && (
                                                ((booking.recurrence_date_0 && new Date(booking.recurrence_date_0).toDateString() === selectedDate.toDateString()) && booking.recurrence_date_0_status === "confirmed") ||
                                                ((booking.recurrence_date_1 && new Date(booking.recurrence_date_1).toDateString() === selectedDate.toDateString()) && booking.recurrence_date_1_status === "confirmed") ||
                                                ((booking.recurrence_date_2 && new Date(booking.recurrence_date_2).toDateString() === selectedDate.toDateString()) && booking.recurrence_date_2_status === "confirmed") ||
                                                ((booking.recurrence_date_3 && new Date(booking.recurrence_date_3).toDateString() === selectedDate.toDateString()) && booking.recurrence_date_3_status === "confirmed")
                                            ))
                                    )
                                    : [];

                                return (
                                    <>
                                        <tr>
                                            <td rowSpan={selectedDayBooking.length + 1} className={styles.Uhrzeit}>
                                                {time}
                                            </td>
                                        </tr>
                                        {selectedDayBooking.map((student, studentIndex) => (
                                            <tr key={studentIndex}>
                                                <td>{student.name}</td>
                                                <td>{student.age} J.</td>
                                                <td>{student.profile_status}</td> 
                                            </tr>
                                        ))}
                                    </>
                                );
                            })}
                        </tbody>
                    </table>
                </div>
            )}


        </div>
    );
}
